import { useProgress } from '../hooks/useProgress';
import WeightEntryForm from '../components/WeightEntryForm';
import Spinner from '../components/Spinner';

export default function Progress() {
  const { entries, trend, loading, addEntry, removeEntry } = useProgress();

  if (loading) return <Spinner label="Loading progress…" />;

  return (
    <div>
      <h2>Progress</h2>

      {trend?.nudge && (
        <div
          style={{
            background: '#fbf3e6',
            border: '1px solid #eddcc0',
            borderRadius: 8,
            padding: '0.75rem 1rem',
            marginBottom: '1rem',
          }}
        >
          {trend.nudge}
        </div>
      )}

      <WeightEntryForm onSubmit={addEntry} />

      <table style={{ borderCollapse: 'collapse', width: '100%', marginTop: '1.5rem' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '0.5rem' }}>Date</th>
            <th style={{ textAlign: 'left', padding: '0.5rem' }}>Weight (kg)</th>
            <th style={{ textAlign: 'left', padding: '0.5rem' }}>Waist (cm)</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.id} style={{ borderTop: '1px solid #e0ddd7' }}>
              <td style={{ padding: '0.5rem' }}>{entry.date}</td>
              <td style={{ padding: '0.5rem' }}>{entry.weightKg}</td>
              <td style={{ padding: '0.5rem' }}>{entry.waistCm ?? '—'}</td>
              <td style={{ padding: '0.5rem' }}>
                <button onClick={() => removeEntry(entry.id)}>Remove</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
